import AccessControl from './AccessControl';

export default ({ to, children }) => (new AccessControl().hasRole(to) ? children : null);
